(() => {
  if (window.kplLangReady) return;
  window.kplLangReady = true;

  const closeAll = (except) => {
    document.querySelectorAll('[data-kpl-lang][open]').forEach((el) => {
      if (el !== except) el.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const inside = event.target.closest('[data-kpl-lang]');
    closeAll(inside);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-kpl-lang][open]');
    if (!open) return;
    open.removeAttribute('open');
    const trigger = open.querySelector('summary');
    if (trigger) trigger.focus();
  });
})();
